var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{attrs:{"variant":"outline-primary","size":"sm","title":_vm.$t('Delete user')},on:{"click":function($event){return _vm.$emit('on-delete')}}},[_c('i',{staticClass:"fas fa-trash",attrs:{"title":_vm.$t('Delete user')}})])}
var staticRenderFns = []

export { render, staticRenderFns }